import _ from 'lodash'
import Signer from '@/models/Signer'
import signersService from '@/modules/signers/services/SignerService'

export default {
  namespaced: true,
  state: () => ({
    signers: [],
    signersHeaders: [
      { text: 'Orden', value: 'orden', width: '30' },
      { text: 'Nombre', value: 'nombreCompleto', width: '180' },
      { text: 'Email', value: 'email', width: '120' },
      { text: 'RFC', value: 'rfc', width: '70' },
      { text: 'Eliminar', value: 'actions', sortable: false, width: '30' }
    ],
    signersHeadersEdit: [
      {
        text: 'Orden',
        value: 'orden',
        sortable: false,
        width: '50',
        class: 'px-0'
      },
      {
        text: 'Nombre',
        value: 'nombreCompleto',
        sortable: false,
        width: '200'
      },
      { text: 'Email', value: 'email', sortable: false, width: '200' },
      { text: 'RFC', value: 'rfc', sortable: false, width: '150' },
      { text: 'Estatus firma', value: 'firmado', sortable: false, width: '85' },
      {
        text: 'Acciones',
        value: 'actions',
        sortable: false,
        width: '95'
      }
    ],
    addSignerVisible: false,
    signersNoDataText: 'No hay firmantes agregados',
    isUserSigner: false,
    userSignerId: '',
    signerDeleteLastLabels:{
      questionText: '¿Quieres eliminar al último firmante?',
      descriptionText:
        'Al eliminar al último firmante, el documento quedará en proceso ¿Deseas continuar?',
      positiveButtonText: 'Si',
      negativeButtonText: 'No'
    },
    signerDeleteLabels: {
      questionText: '¿Quieres eliminar este firmante?',
      descriptionText:
        'Al eliminar a @ aceptas que ya no es necesaria su firma.',
      positiveButtonText: 'Eliminar',
      negativeButtonText: 'Cancelar'
    },
    signerReminderLabels: {
      questionText: '¿Quieres enviar recordatorio a este firmante?',
      descriptionText:
        'Se enviará un correo a @ recordándole que es necesaria su firma en este documento.',
      positiveButtonText: 'Enviar',
      negativeButtonText: 'Cancelar'
    },
    isDeletingSigner: false,
    firmarEnOrden: false,
    msgSignerServiceError:
      'No se pudo realizar la operación solicitada sobre el firmante.',
    msgSignerServiceDeleteError:
      'Ocurrió un error al eliminar el firmante, intente de nuevo más tarde.',
    msgSignerServiceReminderError:
      'Ocurrió un error al enviar el recordatorio al firmante, intente de nuevo más tarde.'
  }),
  mutations: {
    SET_SIGNERS(state, signers) {
      state.signers = signers
    },
    ADD_SIGNER(state, signer) {
      let orden = 1

      if (state.signers.length > 0) {
        const maxSigner = _.maxBy(state.signers, 'orden')
        if (maxSigner) {
          orden = maxSigner.orden + 1
        }
      }

      signer.orden = orden
      signer.firmarEnOrden = state.firmarEnOrden
      state.signers.push(signer)
    },
    DELETE_SIGNER(state, id) {
      state.signers = _.filter(state.signers, s => s.id !== id)
      state.signers = _.orderBy(state.signers, ['orden'], ['asc'])

      for (let i = 0; i < state.signers.length; i++) {
        state.signers[i].orden = i + 1
      }
    },
    SET_ADD_SIGNER_VISIBLE(state, visible) {
      state.addSignerVisible = visible
    },
    SET_IS_USER_SIGNER(state, isUserSigner) {
      state.isUserSigner = isUserSigner
    },
    SET_USER_SIGNER_ID(state, usersignerId) {
      state.userSignerId = usersignerId
    },
    SET_IS_DELETING_SIGNER(state, isDeleting) {
      state.isDeletingSigner = isDeleting
    },
    SET_FIRMAR_EN_ORDEN(state, firmarEnOrden) {
      state.firmarEnOrden = firmarEnOrden

      for (let i = 0; i < state.signers.length; i++) {
        state.signers[i].firmarEnOrden = firmarEnOrden
      }
    }
  },
  actions: {
    addSigner({ commit }, signer) {
      commit('ADD_SIGNER', signer)
    },
    removeSigner({ commit, state }, id) {
      const current = _.filter(state.signers, s => s.id === id)[0]

      if (current && current.isCurrentUser) {
        commit('SET_IS_USER_SIGNER', false)
        commit('SET_USER_SIGNER_ID', '')
      }

      commit('DELETE_SIGNER', id)
    },
    showAddSigner({ commit }) {
      commit('SET_ADD_SIGNER_VISIBLE', true)
    },
    hideAddSigner({ commit }) {
      commit('SET_ADD_SIGNER_VISIBLE', false)
    },
    setUserSigner({ state, commit, rootState }, isUserSigner) {
      const account = rootState.user.account
      let sig = state.signers.find(s => s.email == account.email || s.rfc == account.rfc)
      if(isUserSigner && sig != undefined){
        return
      }

      commit('SET_IS_USER_SIGNER', isUserSigner)

      if (isUserSigner) {
        const signer = new Signer()
        signer.nombres = account.nombres
        signer.paterno = account.paterno
        signer.materno = account.materno
        signer.rfc = account.rfc
        signer.email = account.email
        signer.isCurrentUser = true
        commit('SET_USER_SIGNER_ID', signer.id)
        commit('ADD_SIGNER', signer)
      } else {
        commit('DELETE_SIGNER', state.userSignerId)
        commit('SET_USER_SIGNER_ID', '')
      }
    },
    resetSignersStore({ commit }) {
      commit('SET_SIGNERS', [])
      commit('SET_USER_SIGNER_ID', '')
      commit('SET_IS_USER_SIGNER', false)
      commit('SET_ADD_SIGNER_VISIBLE', false)
      commit('SET_FIRMAR_EN_ORDEN', false)
    },
    saveSigners({ state }, documents) {
      const service = new signersService()

      let signersXdocuments = []
      for (let d of documents) {
        _.forEach(state.signers, s => {
          signersXdocuments.push({
            nombres: s.nombres,
            paterno: s.paterno,
            materno: s.materno,
            rfc: s.rfc,
            email: s.email,
            idDocumento: d.presignUrl.fields['x-amz-meta-DocumentId'],
            orden: s.orden,
            firmarEnOrden: state.firmarEnOrden
          })
        })
      }

      return new Promise((resolve, reject) => {
        service.createSigners({
          firmantes: signersXdocuments
        })
          .then((result) => {
            resolve({
              success: true,
              errorMessage: '',
              data: result
            })  
          })
          .catch(err => {
            let errorMessage =
              'Ocurrio un error al registrar a los firmantes y no pudo realizarse esta operación.'

            if (err.response) {
              if (err.response.status !== 500) {
                errorMessage = err.response.data.error.message
              }
            }

            reject({
              success: false,
              errorMessage
            })
          })
      })
    },
    async notifySigners({ state }, documents) {
      const service = new signersService()

      Promise.all(
        [].map.call(documents, function(document) {
          return service.notifySigners({
            idDocumento: document.presignUrl.fields['x-amz-meta-DocumentId'],
            tipoNotificacion: 1
          })
        })
      )
        .then(function(results) {
          return results
        })
        .then(resultList => {
          return resultList
        })
    },
    notifySignerById({ state }, signerId) {
      const service = new signersService()

      return service.notifySignerById(signerId, {
        tipoNotificacion: 1
      })
    },
    deleteSignerToDocument({ commit }, signer) {
      const service = new signersService()

      return service.deleteSignerToDocument(signer)
    },
    setFirmarEnOrden({ commit }, firmarEnOrden) {
      commit('SET_FIRMAR_EN_ORDEN', firmarEnOrden)
    },
    addSignerToDocument({ commit }, data) {
      const service = new signersService()
      return service.createSigners({ firmantes: [data] })
    },
    updateSignerToDocument({ commit }, data) {
      const service = new signersService()
      data = Object.assign({}, data)
      let id = data.id
      delete data['id']
      return service.updateSignerToDocument(id, data)
    },
    reminderSignerToDocument({ commit }, data) {
      const service = new signersService()
      return service.reminderSignerToDocument(data)
    }
  },
  getters: {
    signers(state) {
      return state.signers
    },
    addSignerVisible(state) {
      return state.addSignerVisible
    },
    signersHeaders(state) {
      return state.signersHeaders
    },
    signersHeadersEdit(state) {
      return state.signersHeadersEdit
    },
    signersNoDataText(state) {
      return state.signersNoDataText
    },
    isUserSigner(state) {
      return state.isUserSigner
    },
    signerDeleteLastLabels(state) { 
    return  state.signerDeleteLastLabels
    },
    signerDeleteLabels(state) {
      return state.signerDeleteLabels
    },
    signerReminderLabels(state) {
      return state.signerReminderLabels
    },
    isDeleting(state) {
      return state.isDeletingSigner
    },
    firmarEnOrden(state) {
      return state.firmarEnOrden
    },
    msgSignerServiceError(state) {
      return state.msgSignerServiceError
    },
    msgSignerServiceDeleteError(state) {
      return state.msgSignerServiceDeleteError
    },
    msgSignerServiceReminderError(state) {
      return state.msgSignerServiceReminderError
    }
  }
}
